import { ValidationResult } from "./types";

export const validRegexEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const validRegexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

export function validateEmail(email: unknown): ValidationResult {
    if (typeof email !== 'string') {
        return { isValid: false, error: 'Введите корректный email' };
    }
    if (email.trim() === '') {
        return { isValid: false, error: 'Поле email не может быть пустым' };
    }
    if (!validRegexEmail.test(email)) {
        return { isValid: false, error: 'Введите корректный email' };
    }
    
    return { isValid: true, error: null };
}
    

export function validatePassword(password: unknown): ValidationResult {
    if (typeof password !== 'string') {
        return { isValid: false, error: 'Введите пароль' };
    }
    if (password.trim() === '') {
        return { isValid: false, error: 'Пароль не может быть пустым' };
    }
    if (!validRegexPassword.test(password)) {
        return{
            isValid: false,
            error: 'Пароль должен содержать минимум 8 символов, строчную и заглавную буквы, цифру и спецсимвол'
    }
    }
    
return { isValid: true, error: null };
}



export function validateConfirmPassword(confirmPassword: unknown, originalPassword: string): ValidationResult {
    if ( typeof confirmPassword !== 'string') {
        return { isValid: false, error: 'Некорректный тип пароля' };
    }
    if (confirmPassword !== originalPassword) {
        return { isValid: false, error: 'Пароли не совпадают' };
    }
    
return { isValid: true, error: null };
}


export function validateOTP(code: unknown): ValidationResult {
    if (typeof code !== 'string') {
        return { isValid: false, error: 'Код не может быть пустым' };
    }
    if (!/^\d{6}$/.test(code)) {
        return { isValid: false, error: 'Код должен содержать только 6 цифры' };
    }
    
return { isValid: true, error: null };
}